
/**
 * 인게이지먼트 통계 정보
 */
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfMediaLinksItemProjectInfoEngagementAllOf = {
  /** 댓글 수 */
  commentCount?: number;
  /** 좋아요 수 */
  likeCount?: number;
  /** 조회수 */
  viewCount?: number;
};
